define([
    'common/ui/view/svg/index',
    'backbone'
], function(
    SVGView,
    Backbone
    ) {
    var BezierQuadraticPointSet = Backbone.Model.extend({
        defaults: {
            point: null,
            controlPoint: {}
        }
    });

    var Builder = Backbone.Model.extend({
        initialize: function(klass) {
            this._klass = klass;
            this._points = [];
        },

        addPoint: function(point, controlPoint) {
            this._points.push(new BezierQuadraticPointSet({
                point: point,
                controlPoint: controlPoint
            }));

            return this;
        },

        build: function() {
            return new this._klass({points: this._points});
        }
    });

    return SVGView.extend({
        tagName: 'path',

        initialize: function(options) {
            this._pointSets = options.points;

            var pointRatio = [];
            var prev = null;
            var sum = 0;
            _.each(this._pointSets, function(p) {
                if(!prev) {
                    pointRatio.push(0);
                } else {
                    var p0 = prev.get('point');
                    var p2 = p.get('point');
                    sum += p0.distance(p2);
                    pointRatio.push(sum);
                }
                prev = p;
            }, this);
            this._pointRatio = _.map(pointRatio, function(r, i) {
                if(sum == 0) {
                    return i / (pointRatio.length - 1);
                }
                return r / sum;
            });
        },

        onRender: function() {
            this.$el.attr('d', this.getSVGPath());

            return this;
        },

        getSVGPath: function() {
            var path = '';
            _.each(this._pointSets, function(p, i) {
                var point = p.get('point');
                var control = p.get('controlPoint');
                var subpath = '';

                if(i == 0) {
                    subpath = `M${point.x} ${point.y} Q${control.x} ${control.y} `;
                } else if(i == 1) {
                    subpath = `${point.x} ${point.y} `;
                } else {
                    subpath = `T${point.x} ${point.y} `;
                }
                path += subpath;
            });

            return path;
        },

        getDividingPoint: function(ratio) {
            var index = null;
            var prevR = 0;
            _.each(this._pointRatio, function(r, i) {
                if(!index && r >= ratio) {
                    index = i;
                    ratio = ratio != 0 ? (ratio - prevR) / (r - prevR) : 0;
                }
                prevR = r;
            });

            var startPointSet = this._pointSets[index - 1];
            if(index > 1) {
                var point = startPointSet.get('point');
                var control = startPointSet.get('controlPoint');
                startPointSet = new BezierQuadraticPointSet({
                    point: point,
                    controlPoint: control ? point.clone().add(point.clone().subtract(control)) : null
                });
            }
            var endPointSet = this._pointSets[index];
            return this._getDividingPoint(startPointSet, endPointSet, ratio);
        },

        _getDividingPoint: function(startPointSet, endPointSet, ratio) {
            var p0 = startPointSet.get('point');
            var p1 = startPointSet.get('controlPoint');
            var p2 = endPointSet.get('point');

            var r = ratio;
            var p3 = p0.clone().mix(p1, r);
            var p4 = p1.clone().mix(p2, r);

            var p5 = p3.clone().mix(p4, r);

            return {
                x: p5.x,
                y: p5.y,
                angle: p4.subtract(p3).invertY().horizontalAngleDeg() + 360,
                // tangent: t
            };
        }
    }, {
        Builder: function() {
            return new Builder(this);
        }
    });
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/line/bezier-quadratic.js